import React, { useState, useEffect, useCallback } from "react";
import Pagination from "../../components/Pagination/Pagination";
import { toast } from "react-toastify";
import "./admincategory.css";
import {
  getAllCategorySubcategory, // Assuming this fetches the full dataset
  createCategory,
  updateCategory,
  deleteAdminCategory,
} from "../../apis";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "../../actions";
import { TablePagination } from "@mui/material";

const AdminCategory = ({
  stopLoadingRequest,
  startLoadingRequest,
  activateModal,
  deactivateModal,
}) => {
  const [categories, setCategories] = useState([]); // Full dataset
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [stylePreference, setStylePreference] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [error, setError] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch categories with search
  const fetch = useCallback(
    async (pageNum, rowsPerPageNum, searchValue = "") => {
      startLoadingRequest();
      try {
        const apiResponse = await getAllCategorySubcategory(
          "category",
          pageNum + 1,
          rowsPerPageNum,
          {
            categoryText: searchValue,
          }
        );
        if (apiResponse?.data?.data) {
          setCategories(apiResponse?.data?.data?.categories);
          setTotalUsers(apiResponse?.data?.data?.totalUsers || 0);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        stopLoadingRequest();
      }
    },
    [startLoadingRequest, stopLoadingRequest]
  );

  // Combined effect for search and pagination
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetch(page, rowsPerPage, searchTerm);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, page, rowsPerPage, fetch]);

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  // Handle creating or updating a category
  const handleSubmitCategory = async (e) => {
    e.preventDefault();

    if (!categoryName || !stylePreference) {
      setError("All fields (category name and style preference) are required");
      return;
    }

    try {
      setError("");
      const formData = {
        name: categoryName,
        stylePreference,
      };

      if (selectedCategory) {
        formData.categoryId = selectedCategory._id;
        await updateCategory(formData);
        toast.success("Category updated successfully!");
      } else {
        await createCategory(formData);
        toast.success("Category created successfully!");
      }

      setIsModalOpen(false);
      fetch(page, rowsPerPage); // Refresh categories list
      resetForm();
    } catch (error) {
      console.error("Error creating/updating category:", error);
      setIsModalOpen(false);
      resetForm();
      toast.error(
        error?.response?.data?.message || "Failed to process the category."
      );
    }
  };

  // Reset the form after submission or cancel
  const resetForm = () => {
    setCategoryName("");
    setStylePreference("");
    setSelectedCategory(null);
  };

  const handleAddCategory = (category = null) => {
    setIsModalOpen(true);

    if (category) {
      setSelectedCategory(category);
      setCategoryName(category.name);
      setStylePreference(category.stylePreference);
    } else {
      resetForm();
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    resetForm();
    setError("");
  };

  const handleDeleteCategory = async (data) => {
     if (data) {
      const response = await deleteAdminCategory({ categoryId: data?._id });
      fetch(page, rowsPerPage);
    }
  };

  return (
    <div className="">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <button
          className="add-category-button-new"
          onClick={() => handleAddCategory(null)}
        >
          Add Category
        </button>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search categories..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: "8px 12px",
              borderRadius: "4px",
              border: "1px solid #ddd",
              width: "300px",
            }}
          />
        </div>
      </div>

      <table className="category-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Category Name</th>
            {/* <th>Gender</th> */}
            <th>Created By</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories?.map((category, index) => (
            <tr key={category._id}>
              <td>{page * rowsPerPage + index + 1}</td>{" "}
              {/* Adjust the index */}
              <td>{category?.name} 
                {/* {category.stylePreference === "Men" ? '♂' : '♀'} */}
                  </td>
                  {/* <td>{category?.stylePreference}</td> */}
                  <td>{category?.coachId ? `${category?.coachId?.firstName} ${category?.coachId?.lastName}` : category?.userId ? `${category?.userId?.firstName} ${category?.userId?.lastName}` : "Admin"}</td>
              <td>
                <div className="table-actions">
                  <button
                    onClick={() => handleAddCategory(category)}
                    disabled={!category?.coachId}
                    className={`edit-button-new ${!category?.coachId ? 'disabled' : ''}`}
                  >
                    Edit
                  </button>

                  <button
                    disabled={!category?.coachId}
                    onClick={() => {
                      handleDeleteCategory(category);
                    }}
                    className={`delete-button-new ${!category?.coachId ? 'disabled' : ''}`}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalUsers}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

      {isModalOpen && (
        <div
          style={{
            zIndex: "10000",
            position: "fixed", // Changed to fixed
            top: 0, // Covering the entire screen
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.4)", // Semi-transparent background
            backdropFilter: "blur(10px)", // Blur effect
          }}
        >
          <div className="modal-content">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h2 style={{ margin: 0 }}>
                {selectedCategory ? "Edit Category" : "Add New Category"}
              </h2>
              <span className="close" onClick={closeModal}>
                &times;
              </span>
            </div>
            <form onSubmit={handleSubmitCategory}>
              <div className="form-group">
                <label htmlFor="categoryName">Category Name</label>
                <input
                  type="text"
                  id="categoryName"
                  name="categoryName"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="stylePreference">Style Preference</label>
                <select
                  id="stylePreference"
                  name="stylePreference"
                  value={stylePreference}
                  onChange={(e) => setStylePreference(e.target.value)}
                  required
                >
                  <option value="" disabled>
                    Select Style Preference
                  </option>
                  <option value="Men">Men</option>
                  <option value="Women">Women</option>
                  <option value="Unisex">Unisex</option>
                </select>
              </div>
              {error && <p style={{ color: "red" }}>{error}</p>}
              <div className="modal-actions">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button type="submit" className="submit-button">
                  {selectedCategory ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* {categories.length > 0 && (
        <Pagination
          pageInfo={{
            page: currentPage,
            total: currentCategories?.length,
            rowsPerPage: rowsPerPage,
          }}
          onPageChange={handlePageChange}
        />
      )} */}
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
      activateModal: actions.modal.activateModal,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AdminCategory);
